export default __webpack_public_path__ + "static/media/be.e5da1b75.svg";